import { Box, Typography } from "@material-ui/core";
import { SwipeableDrawer, styled } from "@mui/material";
import React from "react";
import { useState } from "react";

import { FoundersMembers } from "../../../constants/team";
import Card from "./card";
import DescriptionOffCanvas from "./descriptionCanvas";

const CustomTeam = styled(Box)(({ theme }) => ({
  background: "#FEF8E6",
  padding: "10px 0px 100px 150px",
  ".heading": {
    fontSize: "54px",
    lineHeight: "160%",
    fontWeight: "600",
  },
  ".sub-heading": {
    fontSize: "30px",
    lineHeight: "160%",
    fontWeight: "600",
  },
  ".member-details": {
    margin: "14px 0px",
    display: "flex",
    gap: "24px",
    overflow: "scroll",
    paddingRight: "50px",
    "::-webkit-scrollbar ": {
      display: "none",
    },
  },
  [theme.breakpoints.down("md")]: {
    marginTop: "24px",
    padding: "5px 16px",
    ".heading": {
      fontSize: "12px",
    },
    ".sub-heading": {
      fontSize: "12px",
    },
    ".member-details": {
      flexWrap: "wrap",
      paddingRight: "unset",
    },
  },
}));

const Team = () => {
  const [showDetails, setShowDetails] = useState();
  const [showDescription, setShowDescription] = useState(false);

  const handleClick = (data) => {
    setShowDetails(data);
    setShowDescription(true);
  };

  return (
    <CustomTeam>
      <Box>
        {/* <Typography className="heading">{t('about-us-leadership-heading')}</Typography> */}
        <Typography variant="h2" className="heading">
          {"Founders"}
        </Typography>
        <Box className="member-details">
          {FoundersMembers.map((founder, index) => {
            return (
              <Card
                key={index}
                handleClick={() => {
                  handleClick(founder);
                }}
                details={founder}
              />
            );
          })}
        </Box>
        {/* <Typography className="sub-heading">{t('about-us-commerce')}</Typography> */}
        {/* <Box className="member-details">
                    {
                        CommerceMembers.map((commerce)=>{
                            return(
                                <Card handleClick={()=>{ handleClick(commerce) }} details={commerce} />
                            )
                        })
                    }
                </Box>
                <Typography className="sub-heading">{t('about-us-battery')}</Typography>
                <Box className="member-details">
                    {
                        IOTMembers.map((IOT)=>{
                            return(
                                <Card handleClick={()=>{ handleClick(IOT) }} details={IOT} />
                            )
                        })
                    }
                </Box> */}
        {/* <Typography className="sub-heading">{t('about-us-credit')}</Typography>
                <Box className="member-details">
                    {
                        CreditMembers.map((Credit)=>{
                            return(
                                <Card handleClick={()=>{ handleClick(Credit) }} details={Credit} />
                            )
                        })
                    }
                </Box> */}
        {/* <Typography className="sub-heading">{t('about-us-battery-research')}</Typography>
                <Box className="member-details">
                    {
                        BatteryMembers.map((battery)=>{
                            return(
                                <Card handleClick={()=>{ handleClick(battery) }} details={battery} />
                            )
                        })
                    }
                </Box> */}
        <SwipeableDrawer
          anchor={"right"}
          open={showDescription}
          onClose={() => {
            setShowDescription(false);
          }}
          className="description-offcanvas"
        >
          <DescriptionOffCanvas
            details={showDetails}
            handleClick={() => {
              setShowDescription(false);
            }}
          />
        </SwipeableDrawer>
      </Box>
    </CustomTeam>
  );
};
export default Team;
